/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Sales_Status_OutInputs */

const vi_warehouse_sales_status_out = /** @type {(inputs: Warehouse_Sales_Status_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hết hàng`)
};

/**

* @param {Warehouse_Sales_Status_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_sales_status_out = /** @type {((inputs?: Warehouse_Sales_Status_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Sales_Status_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_sales_status_out(inputs)
});